import React from 'react';
import { Text } from 'react-native';
import Colors from '@global/colors';

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// Splits text on each @mentioned name and renders those runs in blue, matching the Figma spec
// for inline @mention markup (color only, no bold). Uses plain RN Text (not SociollaText) so
// the run only overrides color and otherwise inherits font/lineHeight from its parent Text —
// SociollaText forces its own lineHeight from style.fontSize, which breaks pixel alignment
// when this is used inside the CommentInput overlay (has to match the real TextInput exactly).
export function renderContentWithMentions(content, mentions) {
  if (!content || !mentions || !mentions.length) {
    return content;
  }
  const names = mentions.map(
    (mention) => `@${escapeRegExp(mention.user_name)}`,
  );
  const pattern = new RegExp(`(${names.join('|')})`, 'g');
  return content.split(pattern).map((part, idx) =>
    names.includes(part) ? (
      // eslint-disable-next-line react-native/no-color-literals
      <Text key={idx} style={{ color: Colors.blue13 }}>
        {part}
      </Text>
    ) : (
      part
    ),
  );
}
